import { Component, OnInit, signal } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { AppRestEndPoint } from 'src/app/app-restEndPoint';
import * as _ from 'lodash';
import { ModalConfig } from 'src/app/components/modal/modal.config';
import { ToastService } from 'src/app/components/toaster/toast-service';
import { UtilityService } from 'src/app/services/utility.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadDocumentModalComponent } from '../upload-document-modal/upload-document-modal.component';
import { EventEmitterService } from 'src/app/services/event-emitter.service';
import { UntypedFormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
	selector: 'app-documents',
	templateUrl: './documents.component.html',
	styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent implements OnInit {

	// Modern Angular 17+ signals for state management
	completedDocumentData = signal<any[]>([]);
	documentData = signal<any[]>([]);
	taxDocumentData = signal<any[]>([]);
	docGroup: any;
	documentCount = signal<number>(0);
	complianceDocumentData = signal<any[]>([]);
	currentUser = signal<any>(null);
	activeTabId = 'shared'; // Default active tab for NgbNav
	sharedDocuments = signal<any[]>([]);
	taxDocuments = signal<any[]>([]);
	completedDocuments = signal<any[]>([]);
	documentForm: UntypedFormGroup;
	isLoading = signal<boolean>(false);
	docCount: any;
	environment: any;

	// Accordion state using signals
	expandedItems = signal<Set<string>>(new Set());

	constructor(
		private apiService: ApiService,
		private toastService: ToastService,
		public utilityService: UtilityService,
		public modalService: NgbModal,
		private eventEmitter: EventEmitterService
	) {
		this.environment = environment.environment;
	}

	  ngOnInit(): void {
    this.currentUser.set(JSON.parse(sessionStorage.getItem('current_user') || '{}'));
    this.loadDocument();
    if(this.currentUser().mfa_enabled && this.currentUser().is_authy_enabled){
      this.loadTaxDocuments();
    }
  }

	// Modern accordion toggle method
	toggleAccordion(itemId: string): void {
		const expanded = this.expandedItems();
		const newExpanded = new Set(expanded);
		
		if (newExpanded.has(itemId)) {
			newExpanded.delete(itemId);
		} else {
			newExpanded.add(itemId);
		}
		
		this.expandedItems.set(newExpanded);
	}

	// Check if item is expanded
	isExpanded(itemId: string): boolean {
		return this.expandedItems().has(itemId);
	}

	loadDocument() {
		let url = AppRestEndPoint.DASHBOARD.DOCUMENT_LIST;
		this.apiService.getCall(url, '&user_document_type_id=99').subscribe(data => {
			this.documentData.set([]);
			this.docGroup = [];
			let userDoc = [];
			if (data) {
				if(data.user_documents){
					userDoc = data.user_documents;
					this.documentData.set(_.mapValues(_.groupBy(userDoc, 'created_at_year')));
				}
			}
			let completedDocData = []
			if(this.currentUser().mfa_enabled && this.currentUser().is_authy_enabled){
				this.apiService.getCall(url, '&status=complete&document_type=ips_iaa').subscribe(data => {
					if (data) {
						if(data.user_documents){
							completedDocData = data.user_documents;
							this.completedDocumentData.set(_.mapValues(_.groupBy(completedDocData, 'created_at_year')));
						}
					}
					// Calculate total count after completed documents are loaded
				//	this.calculateTotalDocumentCount();
				});
			} else {
				// Calculate total count if no completed documents
				//this.calculateTotalDocumentCount();
			}
			if(this.currentUser().firm.show_compliance_documents_folder){
				this.apiService.getCall(AppRestEndPoint.DASHBOARD.COMPLAINCE_DOCUMENTS, '').subscribe(data => {
					this.complianceDocumentData.set([]);
					if (data && data.documents) {
						const documents = data.documents
							.filter(document => {
								if (document.document_type === "adv_part_2b_document") {
									return document.url !== null && document.url !== '';
								}
								return true;
							})
							.map(document => {
								if (document.document_type === "adv_part_2b_document") {
									document.description = document.advisor_name + " - Form ADV Part 2B";
								}
								return document;
							});
						this.complianceDocumentData.set(documents);
					}
				});
			}
		});
	}

	loadTaxDocuments() {
		let url = AppRestEndPoint.DASHBOARD.DOCUMENT_LIST;
		this.apiService.getCall(url, '&document_type=tax_document').subscribe(data => {
			this.taxDocumentData.set([]);
			if (data && data.user_documents) {
				if(data.user_documents){
					this.taxDocumentData.set(_.mapValues(_.groupBy(data.user_documents, 'tax_year')));
				}
			}
			// Calculate total count after tax documents are loaded
			//this.calculateTotalDocumentCount();
		});
	}

	orderByDesc = (a, b) => {
		return a.key > b.key ? -1 : (b.key > a.key ? 1 : 0);
	}

	public uploadDocModalConfig: ModalConfig = {
		modalTitle: "Add Document",
		onSubmit: () => {
			//this.saveDocument();
			return true;
		},
		dismissButtonLabel: "Cancel",
		closeButtonLabel: "Add Document",

	}

	setDocumentCount(){
		this.eventEmitter.broadcast("updateDocumentCount", this.documentCount());
		sessionStorage.setItem('user_document_notification_count', JSON.stringify(this.documentCount()));
	}

	calculateTotalDocumentCount() {
		let totalDocumentCount = 0;
		
		// Count all shared documents
		const sharedDocs = this.documentData();
		Object.keys(sharedDocs).forEach(year => {
			if (sharedDocs[year]) {
				totalDocumentCount += sharedDocs[year].length;
			}
		});
		
		// Count all tax documents (if MFA enabled)
		if(this.currentUser().mfa_enabled && this.currentUser().is_authy_enabled) {
			const taxDocs = this.taxDocumentData();
			Object.keys(taxDocs).forEach(year => {
				if (taxDocs[year]) {
					totalDocumentCount += taxDocs[year].length;
				}
			});
			
			// Count all completed documents
			const completedDocs = this.completedDocumentData();
			Object.keys(completedDocs).forEach(year => {
				if (completedDocs[year]) {
					totalDocumentCount += completedDocs[year].length;
				}
			});
		}
		
		// Count compliance documents (if compliance folder is enabled)
		if(this.currentUser().firm.show_compliance_documents_folder) {
			const complianceDocs = this.complianceDocumentData();
			totalDocumentCount += complianceDocs.length;
		}
		
		this.documentCount.set(totalDocumentCount);
		this.setDocumentCount();
	}


	openDocument(document, year, index, docType) {
		// Mark document as read but don't update count since we're showing total documents
		let param = ''
		if (document.is_read == false) {
			if (docType == 'complete') {
				const completedData = this.completedDocumentData();
				if (completedData && completedData[year] && completedData[year][index]) {
					completedData[year][index].is_read = true;
					this.completedDocumentData.set({...completedData});
				}
			} else if(docType == 'tax'){
				const taxData = this.taxDocumentData();
				if (taxData && taxData[year] && taxData[year][index]) {
					taxData[year][index].is_read = true;
					this.taxDocumentData.set({...taxData});
				}
			}else{
				const docData = this.documentData();
				if (docData && docData[year] && docData[year][index]) {
					docData[year][index].is_read = true;
					this.documentData.set({...docData});
				}
			}
			
			
			let documentUnreadCount = JSON.parse(sessionStorage.getItem('user_document_notification_count'));
			documentUnreadCount = documentUnreadCount - 1;
			sessionStorage.setItem('user_document_notification_count', JSON.stringify(documentUnreadCount));
			this.eventEmitter.broadcast("updateDocumentCount", documentUnreadCount);
		}
		docType == 'tax' ?param =  "&document_type=tax_document":'';
		let url = AppRestEndPoint.DASHBOARD.DOWNLOAD_DOCUMENT.replace(':id', document.id);
		this.apiService.getCall(url, param).subscribe(data => {
			if (data && data.url) {
				window.open(data.url, '_blank');
			} else {
				this.toastService.show('Document URL does not exist.', {
					classname: 'bg-danger text-light', delay: 3000
				});
			}
		});
	};

	openUploadDocumentModal() {
		this.modalService.open(UploadDocumentModalComponent,
			{
				windowClass: 'modal-width-850',
				backdrop: 'static'
			}
		).result.then((result) => {
			if (result == 'docUpload') {
				this.loadDocument();
			}
		}, (reason) => {
		});

	}

	openComplianceDocument (url){
        window.open(url, '_blank');
    }

	  loadCompletedDocuments() {
    // Use existing completed document loading logic
    // Already handled in loadDocument method
  }

}
